import { defineMessages } from 'react-intl';

export default defineMessages({
  session: {
    id: 'app.components.PhotoSessionCard.buildTagAttributes.session',
    defaultMessage: 'Sessão: {photoSessionId}',
  },
  pendingChecklist: {
    id: 'app.components.PhotoSessionCard.buildTagAttributes.pendingChecklist',
    defaultMessage: 'Checklist pendente',
  },
  pendingUpload: {
    id: 'app.components.PhotoSessionCard.buildTagAttributes.pendingUpload',
    defaultMessage: 'Upload pendente',
  },
  laterFixedPhotoSession: {
    id: 'app.components.PhotoSessionCard.buildTagAttributes.laterFixedPhotoSession',
    defaultMessage: 'Sessão atrasada',
  },
  laterFlexiblePhotoSession: {
    id: 'app.components.PhotoSessionCard.buildTagAttributes.laterFlexiblePhotoSession',
    defaultMessage: 'Sessão livre há {daysAhead} dias',
  },
  forSale: {
    id: 'app.components.PhotoSessionCard.BusinessContextTag.forSale',
    defaultMessage: 'Venda',
  },
  forRent: {
    id: 'app.components.PhotoSessionCard.BusinessContextTag.forRent',
    defaultMessage: 'Aluguel',
  },
  ownerPhotos: {
    id: 'app.components.PhotoSessionCard.BusinessContextTag.ownerPhotos',
    defaultMessage: 'Fotos do proprietário',
  },
  problemReported: {
    id: 'app.components.PhotoSessionCard.ProblemSessionNotice.problemReported',
    defaultMessage: 'Problema reportado',
  },
  rescheduleDaysLeft: {
    id: 'app.components.PhotoSessionCard.ProblemSessionNotice.rescheduleDaysLeft',
    defaultMessage: 'Reagende em até {days} dias',
  },
  rescheduleLastDay: {
    id: 'app.components.PhotoSessionCard.ProblemSessionNotice.rescheduleLastDay',
    defaultMessage: 'Último dia para reagendar',
  },
  rescheduleInfo: {
    id: 'app.components.PhotoSessionCard.ProblemSessionNotice.rescheduleInfo',
    defaultMessage: 'Sessões com problema ficam nesta aba por até 3 dias para você reagendar. '
    + 'Depois disso, elas saem da sua agenda. Fale com o suporte para reagendar.',
  },
  rescheduleInfoAriaLabel: {
    id: 'app.components.PhotoSessionCard.ProblemSessionNotice.rescheduleInfoAriaLabel',
    defaultMessage: 'Saiba mais sobre o prazo para reagendar',
  },
  rescheduleButton: {
    id: 'app.components.PhotoSessionCard.ProblemSessionNotice.rescheduleButton',
    defaultMessage: 'Reagendar',
  },
});
